import { TrackingService } from '@actiris/forms';
import { Component, inject } from '@angular/core';

@Component({
    selector: 'app-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent {
    private tracking = inject(TrackingService);

    public get showBanner() {
        return this.tracking.shouldAskForTracking;
    }

    public accept() {
        this.tracking.acceptTracking();
    }
}
